import React from "react";
import { attraction } from "../data/Data";
import CommonHeading from "../common/CommonHeading";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

export default function Attractions({ isTop = false }) {
  const settings = {
    dots: true,
    infinite: true,
    autoplay: true,
    autoplaySpeed: 0,
    speed: 6000,
    cssEase: "linear",
    pauseOnHover: true,
    rtl: false,
    slidesToShow: 4,
    slidesToScroll: 1,
    arrows: false,
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          centerMode: true,
          centerPadding: "65px",
          autoplay: true,
          autoplaySpeed: 3000,
          speed: 600,
          cssEase: "ease-in-out",
          arrows: false,
          dots: true,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          centerMode: true,
          centerPadding: "50px",
          autoplay: true,
          autoplaySpeed: 3000,
          speed: 600,
          cssEase: "ease-in-out",
          arrows: false,
          dots: true,
        },
      },
    ],
  };

  return (
    <>
      <section 
        className={`hk-attraction-section ${isTop ? "hk-top-section" : ""} my-0 position-relative`} 
        style={{ padding: "32px 0", background: "linear-gradient(180deg, #FAF6F0 0%, #F2EAE0 50%, #FAF6F0 100%)" }} 
        aria-label="Nearby Attractions"
      >
        <div className="container" style={{ maxWidth: "1140px", margin: "0 auto" }}>
          <CommonHeading
            heading="Nearby Attractions"
            subtitle="Discover Nearby Attractions within"
            title="10 Km"
          />
          <Slider {...settings} className="attraction-carousel">
            {attraction.map((item, index) => (
              <div key={index} className="attraction-slide-wrapper">
                <div className="attraction-card">
                  <div className="image-wrapper">
                    <img className="img-fluid" src={item.image} alt="img" />
                    <a
                      className="map-icon"
                      href={`https://www.google.com/maps?q=${encodeURIComponent(item.location)}`}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <i className="fas fa-map-marker-alt"></i>
                    </a>
                  </div>
                  <div className="content">
                    <h5>{item.name}</h5>
                    <small>{item.designation}</small>
                  </div>
                </div>
              </div>
            ))}
          </Slider>
        </div>
      </section>

      <style>{`
        .attraction-carousel {
          padding: 0;
        }

        .attraction-carousel:hover .slick-track,
        .attraction-slide-wrapper:hover .slick-track,
        .attraction-card:hover .slick-track {
          transition-property: none !important;
          animation-play-state: paused !important;
        }

        @media (min-width: 769px) {
          .attraction-carousel .slick-track {
            transition-timing-function: linear !important;
          }
        }

        .attraction-slide-wrapper {
          padding: 15px 12px;
          height: 100%;
          direction: ltr !important;
          text-align: left;
        }

        .attraction-card {
          background: #FFFFFF;
          border-radius: 24px;
          overflow: hidden;
          box-shadow: 0 8px 24px rgba(11, 29, 55, 0.05);
          transition: all 0.4s cubic-bezier(0.16, 1, 0.3, 1);
          border: 1.5px solid rgba(212, 175, 55, 0.25) !important;
          display: flex;
          flex-direction: column;
          height: 380px;
          width: 100%;
        }

        .attraction-card:hover {
          transform: translateY(-8px) scale(1.02);
          box-shadow: 0 16px 36px rgba(254, 161, 22, 0.18);
        }

        .image-wrapper {
          position: relative;
          height: 190px !important;
          min-height: 190px !important;
          max-height: 190px !important;
          overflow: hidden !important;
          background: #0B1D37;
          flex-shrink: 0 !important;
        }

        .image-wrapper img {
          width: 100% !important;
          height: 100% !important;
          object-fit: cover !important;
          object-position: center !important;
          transition: transform 0.6s cubic-bezier(0.16, 1, 0.3, 1);
          filter: brightness(0.95);
        }

        .attraction-card:hover .image-wrapper img {
          transform: scale(1.08);
          filter: brightness(1.0);
        }

        .map-icon {
          position: absolute;
          bottom: 0.9rem;
          right: 0.9rem;
          width: 44px;
          height: 44px;
          background: linear-gradient(135deg, #FEA116 0%, #D4AF37 100%);
          color: #050E1A !important;
          font-size: 1.15rem;
          border-radius: 50%;
          box-shadow: 0 4px 14px rgba(5, 14, 26, 0.35);
          z-index: 10;
          transition: transform 0.3s ease, box-shadow 0.3s ease;
          display: flex;
          align-items: center;
          justify-content: center;
          border: 1.5px solid #FFFFFF;
          text-decoration: none !important;
        }

        .map-icon i {
          color: #050E1A !important;
          opacity: 1 !important;
          visibility: visible !important;
        }

        .map-icon:hover {
          background: linear-gradient(135deg, #FEA116 0%, #D4AF37 100%);
          transform: scale(1.1);
          box-shadow: 0 8px 22px rgba(254, 161, 22, 0.6);
        }

        .content {
          text-align: center;
          padding: 1.6rem 1.4rem;
          color: #1A283B;
          font-family: 'Poppins', sans-serif;
          background: transparent;
          flex: 1;
          display: flex;
          flex-direction: column;
          justify-content: flex-start;
        }

        .content h5 {
          font-size: 1.2rem;
          font-weight: 700;
          margin-bottom: 0.5rem;
          color: #0B1D37;
          font-family: "Cinzel", serif;
          text-transform: uppercase;
          letter-spacing: 0.05em;
          position: relative;
          padding-bottom: 8px;
        }

        .content h5::after {
          content: "";
          position: absolute;
          bottom: 0;
          left: 50%;
          transform: translateX(-50%);
          width: 35px;
          height: 1.5px;
          background: #D4AF37;
          opacity: 0.6;
        }

        .content small {
          font-size: 0.88rem;
          color: #53647C;
          line-height: 1.6;
          display: block;
          margin-top: 8px;
        }

        /* 🌟 MOBILE CENTERED CAROUSEL WITH BOTH SIDE PEEKS 🌟 */
        @media (max-width: 768px) {
          .attraction-slide-wrapper {
            padding: 12px 6px;
          }
          .attraction-carousel .slick-track {
            transition-timing-function: ease-in-out !important;
          }
          .attraction-carousel .slick-list {
            padding-top: 15px !important;
            padding-bottom: 25px !important;
            overflow: hidden !important;
          }
          .attraction-carousel .slick-slide {
            transition: transform 0.45s cubic-bezier(0.16, 1, 0.3, 1), opacity 0.45s ease, filter 0.45s ease !important;
            transform: scale(0.85) !important;
            opacity: 0.55 !important;
            filter: brightness(0.85) !important;
            z-index: 1 !important;
          }
          .attraction-carousel .slick-slide.slick-center {
            transform: scale(1.02) !important;
            opacity: 1 !important;
            filter: brightness(1) !important;
            z-index: 10 !important;
          }
          .attraction-carousel .slick-slide.slick-center .attraction-card {
            border: 2px solid rgba(212, 175, 55, 0.85) !important;
            box-shadow: 0 16px 36px rgba(254, 161, 22, 0.28) !important;
          }
          .attraction-carousel .slick-dots {
            bottom: -8px;
          }
          .attraction-carousel .slick-dots li button:before {
            color: #D4AF37;
            opacity: 0.4;
            font-size: 8px;
          }
          .attraction-carousel .slick-dots li.slick-active button:before {
            color: #FEA116;
            opacity: 1;
            font-size: 10px;
          }
        }

        @media (max-width: 576px) {
          .image-wrapper {
            height: 170px !important;
            min-height: 170px !important;
            max-height: 170px !important;
          }

          .content h5 {
            font-size: 1.05rem;
          }

          .content small {
            font-size: 0.82rem;
          }
        }
      `}</style>
    </>
  );
}
